import Tab from '@mui/material/Tab';

import { PermissionsEnum } from '@/auth/interfaces/permissions.enum';
import {
  EstadosOrdenTrabajoEnumChoice,
  ROUTER_PATHS,
  a11yProps,
  getEnvs,
  hasPermission,
  useCheckPermissions,
  useLoaders,
  useTabsFormOnly,
} from '@/shared';
import {
  CustomTabPanel,
  FormTabsOnly,
  SingleBoxTableTabsOnly,
  SingleTableBoxScene,
} from '@/shared/components/ui';
import InstalacionesAsignadasTecnicoPage from './InstalacionesAsignadasTecnicoPage';
import InstallAsignadaTecnicoOTByState from './InstallAsignadaTecnicoOTByState';
import { Visibility } from '@mui/icons-material';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useSystemParamsStore } from '@/store/erp';

const { VITE_NODE_ENV } = getEnvs()
interface ParametroHorario {
  hora: number;
  max_dia: number;
  min_dia: number;
}

const VALORES_POR_DEFECTO: ParametroHorario = {
  hora: 3,
  max_dia: 5,
  min_dia: 9,
};


export type InstalacionesTecnicoPageProps = {};

const InstalacionesTecnicoPage: React.FC<
  InstalacionesTecnicoPageProps
> = () => {

  const systemParams = useSystemParamsStore(s => s.systemParams);
  const isLoadingSystemParams = useSystemParamsStore(s => s.isLoadingSystemParams);

  useCheckPermissions(PermissionsEnum.api_view_ordentrabajo);
  const returnUrlInstalacionesTecnicoPage =
    ROUTER_PATHS.tecnico.ordenenTrabajoNav;
  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: hasPermission(PermissionsEnum.revision_contabilidad_tecnico) ? 8 : 1,
  });

  const [parametroSistema, setParametroSistema] = useState<{ hora: number, max_dia: number, min_dia: number } | null>(null);


  useEffect(() => {
    if (isLoadingSystemParams || !systemParams) return;
    const param = systemParams.find(e => e.slug === 'DIA_HORA_FILTRO_ANTES_ORDEN_TRABAJO');
    if (!param?.valor) return;

    try {
      const parsed = param?.valor ? JSON.parse(param.valor) : null;
      const data = typeof parsed === "object" && parsed !== null ? parsed : {};
      const {
        hora = VALORES_POR_DEFECTO.hora,
        max_dia = VALORES_POR_DEFECTO.max_dia,
        min_dia = VALORES_POR_DEFECTO.min_dia,
      }: Partial<ParametroHorario> = data;

      setParametroSistema({ hora, max_dia, min_dia });
    } catch (error) {
      console.error("Error al parsear DIA_HORA_FILTRO_ANTES_ORDEN_TRABAJO:", error);
      // Asignar los valores por defecto si el JSON está mal formado sintácticamente
      setParametroSistema(VALORES_POR_DEFECTO);
    }

  }, [isLoadingSystemParams, systemParams]);

  useLoaders(isLoadingSystemParams)

  return (
    <SingleTableBoxScene title={'Instalaciones'}>
      <SingleBoxTableTabsOnly>

        {
          /** Array de usuarios que pueden ver todos los tabs */
          (hasPermission(PermissionsEnum.administration_manage_system) || VITE_NODE_ENV === 'dev') ?
            (
              <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
                <Tab label="Asignadas" value={1} {...a11yProps(1)} />
                <Tab label="Asignadas Recoordinadas" value={2} {...a11yProps(2)} />
                <Tab label="Realizadas" value={4} {...a11yProps(4)} />
                <Tab label="Pendientes Actualización" value={6} {...a11yProps(6)} />
                <Tab label="Fallidas" value={7} {...a11yProps(7)} />
                <Tab label="Revisión Contabilidad" value={8} {...a11yProps(8)} />
              </FormTabsOnly>
            )
            :
            hasPermission(PermissionsEnum.revision_contabilidad_tecnico) ?
              <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
                <Tab label="Revisión Contabilidad" value={8} {...a11yProps(8)} />
              </FormTabsOnly>
              :
              <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
                <Tab label="Asignadas" value={1} {...a11yProps(1)} />
                <Tab label="Asignadas Recoordinadas" value={2} {...a11yProps(2)} />
                <Tab label="Realizadas" value={4} {...a11yProps(4)} />
                <Tab label="Pendientes Actualización" value={6} {...a11yProps(6)} />
                <Tab label="Fallidas" value={7} {...a11yProps(7)} />
              </FormTabsOnly>
        }


      </SingleBoxTableTabsOnly>

      {/* ============ Asignadas ============ */}
      <CustomTabPanel value={valueTab} index={1}>
        <InstalacionesAsignadasTecnicoPage
          tipo_orden_servicio_exclude="TRASLADO,VISITA"
          hora_liberacion={parametroSistema?.hora ? Number(parametroSistema.hora) : null}
          max_dia_liberacion={parametroSistema?.max_dia ? Number(parametroSistema.max_dia) : null}
          min_dia_liberacion={parametroSistema?.min_dia ? Number(parametroSistema.min_dia) : null}
          filtro_horario_instalacion={true}
        />
      </CustomTabPanel>

      {/* ============ Asignadas Recoordinadas ============ */}
      <CustomTabPanel value={valueTab} index={2}>
        <InstalacionesAsignadasTecnicoPage
          stateOT={EstadosOrdenTrabajoEnumChoice.ESPERA_RECOORDINADA}
          editPath={`${returnUrlInstalacionesTecnicoPage}/asignadas/recoordinada`}
          tipo_orden_servicio_exclude="TRASLADO,VISITA"
          hora_liberacion={parametroSistema?.hora ? Number(parametroSistema.hora) : null}
          max_dia_liberacion={parametroSistema?.max_dia ? Number(parametroSistema.max_dia) : null}
          min_dia_liberacion={parametroSistema?.min_dia ? Number(parametroSistema.min_dia) : null}
          filtro_horario_instalacion={true}
        />
      </CustomTabPanel>

      {/* ============ Pendientes Actualizar ============ */}
      {/* <CustomTabPanel value={valueTab} index={3}>
        PENDIENTES ACTUALIZAR
      </CustomTabPanel> */}

      {/* ============ Realizadas ============ */}
      <CustomTabPanel value={valueTab} index={4}>
        <InstallAsignadaTecnicoOTByState
          otState={EstadosOrdenTrabajoEnumChoice.REALIZADA}
          showActions={false}
          tipoOrdenServicioExclude="TRASLADO,VISITA"
        />
      </CustomTabPanel>

      {/* ============ Pendientes Actualización ============ */}
      <CustomTabPanel value={valueTab} index={6}>
        <InstalacionesAsignadasTecnicoPage
          stateOT={EstadosOrdenTrabajoEnumChoice.ESPERA_ACTUALIZAR}
          editPath={`${returnUrlInstalacionesTecnicoPage}/asignadas/pendientes-actualizar`}
          tipo_orden_servicio_exclude="TRASLADO,VISITA"
        />
      </CustomTabPanel>

      {/* ============ Fallidas ============ */}
      <CustomTabPanel value={valueTab} index={7}>
        <InstallAsignadaTecnicoOTByState
          otState={EstadosOrdenTrabajoEnumChoice.RECHAZADA}
          showActions={false}
          tipoOrdenServicioExclude="TRASLADO,VISITA"
        />
      </CustomTabPanel>

      {/* ============ Revisión Contabilidad ============ */}
      {
        hasPermission(PermissionsEnum.revision_contabilidad_tecnico) && (
          <CustomTabPanel value={valueTab} index={8}>
            <InstalacionesAsignadasTecnicoPage
              stateOT={EstadosOrdenTrabajoEnumChoice.REALIZADA}
              editIcon={<Visibility />}
              editPath={`${returnUrlInstalacionesTecnicoPage}/revision-ordenes-trabajo-realizadas`}
              tipo_orden_servicio_exclude="TRASLADO,VISITA"
            />
          </CustomTabPanel>
        )
      }
    </SingleTableBoxScene>
  );
};

export default InstalacionesTecnicoPage;
